import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';
import InlineRegionSelect from '../inputs/InlineRegionSelect';
import InlineItemSelect from '../inputs/InlineItemSelect';


const ItemHasNoCorporateItemLinkRule = (props) => {
  const {
    form, onSubmit, initialValues, ...other
  } = props;
  const [regions, setRegions] = useState(
    !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
  );
  const [excludedSuppliers, setSuppliers] = useState(initialValues.excluded_suppliers || []);
  const [excludedItems, setItems] = useState(initialValues.excluded_items || []);

  const submit = useCallback((event) => {
    event.preventDefault();
    onSubmit({
      kind: 'has_no_item_link',
      regions: _.filter(regions),
      value: {
        excluded_suppliers: excludedSuppliers,
        excluded_items: _.isEmpty(excludedItems) ? [] : _.filter(_.map(excludedItems.split(','), val => parseInt(val, 10)), val => val),
      }
    });
  }, [excludedItems, excludedSuppliers, onSubmit, regions]);

  const onReset = useCallback(() => {
    setSuppliers(initialValues.excluded_suppliers || []);
    setItems(initialValues.excluded_items || []);
    setRegions(
      !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
    );
  }, [initialValues.excluded_items, initialValues.excluded_suppliers, initialValues.regions]);


  return (
    <RuleForm
      {...other}
      onSubmit={submit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    >
      <InlineRegionSelect
        value={regions}
        onChange={setRegions}
      />
      <InlineSupplierSelect
        value={excludedSuppliers}
        label='Suppliers'
        mode='multiple'
        description='Suppliers to be excluded'
        onChange={setSuppliers}
        placeholder='Select suppliers...'
        include_all={false}
        include_any={false}
      />
      <InlineItemSelect
        value={excludedItems}
        onChange={setItems}
        include_all={false}
        include_any={false}
      />
    </RuleForm>
  );
};

ItemHasNoCorporateItemLinkRule.defaultProps = {
  initialValues: {}
};

ItemHasNoCorporateItemLinkRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  initialValues: PropTypes.object,
};

export default ItemHasNoCorporateItemLinkRule;
